import ActionTypes from '../constants';

const initialState = {
    vehicles: {},
    vehicle: {},
    customerVehicles: {},
    loading: false,
};

const vehicleReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GETVEHICLESUCCESS:
            return {
                ...state,
                vehicles: action.payload,
            }
        case ActionTypes.LOADING:
            return {
                ...state,
                loading: true
            }
        case ActionTypes.GETVEHICLEBYIDSUCCESS:
            return {
                ...state,
                vehicle: action.payload,
            }
        case ActionTypes.GETVEHICLEBYCUSTOMERIDSUCCESS:
            return {
                ...state,
                customerVehicles: action.payload,
            }
        default:
            return state;
    }
}

export default vehicleReducer;